import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import cx from 'classnames';
import root from 'window-or-global';
import Link from 'epic-diesel-common/src/components/link/Link';
import {generateRoutePath} from 'epic-common/src/route';
import {Icon} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import styles from './Header.pcss';
import Message from '../common/Message';
import Locale from './Locale';
import {AlertBar} from '../';

const ON_DISPLAY = 'ON_DISPLAY';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuActive: false
        };
    }
    static propTypes = {
        headerClass: PropTypes.string,
        affiliateAccount: PropTypes.object,
        accountInfo: PropTypes.object,
        configState: PropTypes.object
    };

    toggleMenu = () => {
        this.setState({menuActive: !this.state.menuActive});
    };

    render() {
        const {headerClass, affiliateAccount, accountInfo, configState} = this.props;
        const {menuActive} = this.state;
        const isLoggedIn = accountInfo && accountInfo.isLoggedIn;

        // TODO: Check the config store. If 'useEpicHeader' is set to true
        // then this should render the standard Epic Games header. If it's set
        // to false, we render what we have below. If 'loading', then we don't
        // render anything yet

        const showTabs =
            affiliateAccount &&
            affiliateAccount.status !== 'INIT' &&
            affiliateAccount.status !== 'REJECTED' &&
            affiliateAccount.status !== 'DISABLED' &&
            affiliateAccount.status !== 'PENDING';
        const isActive = affiliateAccount && affiliateAccount.status === 'ACTIVE';

        const headerClassWrapper = cx(headerClass, styles.header, {
            [styles.menuActive]: menuActive
        });

        // TODO: The check should be more than just "affiliateAccount". It needs to check whether
        // the affiliate is actually approved before we show any of the other header links
        const menuLinks = showTabs ? (
            <div className={styles.menuLinks}>
                <NavLink activeClassName={styles.active} to={generateRoutePath('overview')}>
                    <Message code="epic.affiliate.nav.overview" />
                </NavLink>

                {/* <NavLink activeClassName={styles.active} to={generateRoutePath('news')}>
                        <Message code="epic.affiliate.nav.resources" />
                    </NavLink> */}

                {configState && configState.enableEarnings && isActive && (
                    <NavLink activeClassName={styles.active} to={generateRoutePath('dashboard')}>
                        <Message code="epic.affiliate.nav.earnings" />
                    </NavLink>
                )}

                {isActive && (
                    <NavLink activeClassName={styles.active} to={generateRoutePath('payout')}>
                        <Message code="epic.affiliate.nav.payout" />
                    </NavLink>
                )}

                {isActive && (
                    <NavLink activeClassName={styles.active} to={generateRoutePath('settings')}>
                        <Message code="epic.affiliate.nav.settings" />
                    </NavLink>
                )}
            </div>
        ) : (
            <div className={styles.menuLinks} />
        );

        const handleOnClickLogout = () => {
            if (root.sessionStorage) {
                root.sessionStorage.removeItem(ON_DISPLAY);
            }
        };

        return [
            <bdo key="HEADER" dir="ltr">
                <div className={headerClassWrapper}>
                    <div className={styles.logoHeader}>
                        <a className={styles.logoLink} href="https://www.epicgames.com">
                            <Icon icon={svgs.EPIC} size={sizes.LARGE} />
                        </a>
                        <Message className={styles.advocateTitle} code="epic.affiliate.nav.title" />
                    </div>
                    <div className={styles.menuControl}>
                        {showTabs && (
                            <button onClick={this.toggleMenu}>
                                <Icon icon={svgs.CHEVRON_DOWN} size={sizes.XSMALL} />
                            </button>
                        )}
                    </div>
                    {menuLinks}
                    <div className={styles.user}>
                        {isLoggedIn && <span>{accountInfo.displayName}</span>}
                        {isLoggedIn ? (
                            <Link to="/logout" onClick={handleOnClickLogout} isExternalUrl={true}>
                                <Message code="epic.affiliate.common.signout" />
                            </Link>
                        ) : (
                            <Link to="/login" isExternalUrl={true}>
                                <Message code="epic.affiliate.common.signin" />
                            </Link>
                        )}
                    </div>
                    <Locale />
                </div>
                <AlertBar key="alert" />
            </bdo>
        ];
    }
}
